module.exports = "<div class=\"js-sticky-placeholder u-hide\"></div>\n<div class=\"js-sticky\">\n    <div class=\"js-sticky-inner\">\n        <content></content>\n    </div>\n</div>\n";
